module.exports = __webpack_public_path__ + "static/logo_puck-5c4221f33804eacbcd6c4169a2085b5d.svg";